export default __webpack_public_path__ + "static/media/django.78870b1f.svg";